import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type StatusConnectedIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const StatusConnectedIcon = ({ strokeWidth, ...props }: StatusConnectedIconProps) => (
  <BaseIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    strokeWidth={strokeWidth}
    title="Status Connected Icon"
    desc="A status icon representing a Profile to which you are connected"
    {...props}
  >
    <rect width="20" height="20" fill="#3E5DF2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 4.5C12.3954 4.5 11.5 5.39543 11.5 6.5C11.5 7.60457 12.3954 8.5 13.5 8.5C14.6046 8.5 15.5 7.60457 15.5 6.5C15.5 5.39543 14.6046 4.5 13.5 4.5ZM10.5 6.5C10.5 4.84315 11.8431 3.5 13.5 3.5C15.1569 3.5 16.5 4.84315 16.5 6.5C16.5 8.15685 15.1569 9.5 13.5 9.5C12.8521 9.5 12.2522 9.29462 11.7618 8.94541L8.94541 11.7618C9.29462 12.2522 9.5 12.8521 9.5 13.5C9.5 15.1569 8.15685 16.5 6.5 16.5C4.84315 16.5 3.5 15.1569 3.5 13.5C3.5 11.8431 4.84315 10.5 6.5 10.5C7.14793 10.5 7.74789 10.7054 8.23831 11.0547L11.0547 8.23831C10.7054 7.74789 10.5 7.14793 10.5 6.5ZM6.5 11.5C5.39543 11.5 4.5 12.3954 4.5 13.5C4.5 14.6046 5.39543 15.5 6.5 15.5C7.60457 15.5 8.5 14.6046 8.5 13.5C8.5 12.3954 7.60457 11.5 6.5 11.5Z"
      fill="white"
    />
  </BaseIcon>
);

StatusConnectedIcon.displayName = 'StatusConnectedIcon';
